import type {
  ReportSeverityDescriptions,
  ReportSeverityResults,
} from '@ipfabric/utils';
import { prop } from '@ipfabric/utils/fp/prop';
import { useGraphContextSelectors } from 'components/Graph/GraphContext';
import { checkIntent } from 'components/Graph/commands/checkIntent';
import { SeverityCountsListItem } from 'components/SeverityCounts/SeverityCountsListItem';
import { useLocale } from 'containers/App/LocaleContext';
import { type FC, memo } from 'react';

export interface IntentVerificationListSearchResult {
  childId: string;
  childTitle: string;
  groupTitle: string;
  results: ReportSeverityResults;
  descriptions: {
    checks: ReportSeverityDescriptions;
    general: string;
  };
}

interface Props {
  searchResults: IntentVerificationListSearchResult[];
}

const BareIntentVerificationListSearchResults: FC<Props> = (props) => {
  const ctxProps = useGraphContextSelectors({
    dispatch: prop('dispatch'),
  });
  const msg = useLocale();

  if (!props.searchResults.length) {
    return (
      <div className='px-lgu-3 pt-lgu-1'>
        {
          msg.canvasGraph.graphSidePanel.intentVerification
            .definedRulesNoSearchResults
        }
      </div>
    );
  }

  return (
    <>
      {props.searchResults.map((result) => (
        <SeverityCountsListItem
          className='severity-counts-list-item--intents'
          key={result.childId}
          name={
            <div>
              <div className='font-semibold'>{result.childTitle}</div>
              <div className='text-lgu-base font-bold'>{result.groupTitle}</div>
            </div>
          }
          onClick={() => {
            ctxProps.dispatch(checkIntent, {
              intentRule: result.childId,
            });
          }}
          counts={result.results}
          descriptions={result.descriptions.checks}
          tooltip={result.descriptions.general}
        />
      ))}
    </>
  );
};

export const IntentVerificationListSearchResults = memo(
  BareIntentVerificationListSearchResults,
);
